import { render, staticRenderFns } from "./deliveryFailed.vue?vue&type=template&id=6cf9fe39&scoped=true"
import script from "./deliveryFailed.vue?vue&type=script&lang=js"
export * from "./deliveryFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf9fe39",
  null
  
)

export default component.exports